<template>
  <div>
    <div
      v-if="showCameraVisibilityIssue"
      class="camera-visibility-issue text-left"
    >
      <img src="@/assets/images/user-distance.png" class="mb-2" />
      <p class="mb-2 font-weight-700 text-white font-24">
        Cannot See You!
      </p>
      <p class="font-weight-500 mb-3 text-secondary font-16">
        Please step back a bit, you're not fully visible
      </p>
      <p class="font-weight-700 text-white font-18" v-if="allowPause">
        Pausing in {{ pauseCountdownTimer }} seconds
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CameraVisibilityIssue",
  data() {
    return {
      pauseCountdownTimer: 4,
      pauseCountdownTimerInterval: null,
    };
  },
  props: {
    showCameraVisibilityIssue: { type: Boolean, default: false },
    allowPause: { type: Boolean, default: false },
  },
  watch: {
    showCameraVisibilityIssue(newVal) {
      // if workout is not allowed to pause then not start the timer
      if (!this.allowPause) {
        return;
      }
      const ctx = this;
      if (newVal) {
        this.pauseCountdownTimerInterval = setInterval(() => {
          ctx.pauseCountdownTimer--;
          if (ctx.pauseCountdownTimer < 0) {
            ctx.pauseCountdownTimer = 4;
          }
        }, 1000);
      } else {
        this.pauseCountdownTimerInterval &&
          clearInterval(this.pauseCountdownTimerInterval);
        this.pauseCountdownTimer = 4;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.camera-visibility-issue {
  position: absolute;
  top: 50%;
  left: 50%;
  right: 0;
  z-index: 25;
  background: rgba(57, 56, 56, 0.8);
  padding: 20px;
  border-radius: 10px;
  max-width: 400px;
  transform: translate(-50%, -50%);
  img {
    width: 100%;
    // background-color: #ffffff;
    border-radius: 5px;
    @media (max-width: 992px) {
      width: 10rem;
      margin: auto;
    }
  }
  p {
    margin-bottom: 0;
    color: white;
  }
  .text-secondary {
    color: #cccccc !important;
    font-weight: 300 !important;
  }
}
</style>
